import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const brownCardBlockSchema = z.object({
	contentHtml: nonEmptyString,
	heading: nonEmptyString,
});
